export default "__VITE_ASSET__BntJwLKR__"